<template>
  <div>
    <div class="row align-items-center">
      <div class="col">
        <!-- <base-button outline  type="default">
                <i class="fa fa-plus"></i>新規追加
                </base-button> -->
        
        <!-- コンテキストメニュー -->
        <!-- ※コンテキストメニューの実装はProjectViewに移設 -->
        <card
          v-if="false"
          id="contextMenu"
          ref="contextMenu"
          class="dropdown-menu tree-context-menu context-menu"
          :noBody=true
          :style="context_position"
          style="cursor: pointer;"
          v-show="treeContextShow">
          <!-- フォルダ追加 -->
          <a v-show="tree.addFolder" class="dropdown-item pt-1 pb-1" @click="handlerMenuAddFolder" ><i class="fa fa-folder-plus text-primary"></i>{{$t('ツリー.1')}}</a>
          <div v-show="tree.div1" class="dropdown-divider"></div>
          <!-- フォーム追加 -->
          <a v-show="tree.addForm" class="dropdown-item pt-1 pb-1" @click="handlerMenuAddInspect"><i class="fa fa-notes-medical text-primary"></i>{{$t('ツリー.2')}}</a>
          <!-- フォーム編集 -->
          <a v-show="tree.editForm" class="dropdown-item pt-1 pb-1" @click="handlerMenuBackImageSetting"><i class="fa fa-tools text-primary"></i>{{$t('ツリー.4')}}</a>
          <!-- ファイル追加 -->
          <a v-show="tree.addFile" class="dropdown-item pt-1 pb-1" @click="handlerAddfile"><i class="far fa-file-image text-primary"></i>{{$t('ツリー.3')}}</a>
          <div v-show="tree.div2" class="dropdown-divider"></div>
          <!-- 名前変更 -->
          <a v-show="tree.rename" class="dropdown-item pt-1 pb-1" @click="handlerMenuRename"><i class="el-icon-edit text-primary"></i>{{$t('ツリー.5')}}</a>
          <div v-show="tree.div3" class="dropdown-divider"></div>
          <!-- 削除 -->
          <a v-show="tree.delete" class="dropdown-item pt-1 pb-1" @click="handlerMenuDeleteNode"><i class="fa fa-trash-alt text-primary"></i>{{$t('ツリー.6')}}</a>
        </card>
      </div>
    </div>

    <div class="mt-2 mr-2">
      <!-- <el-tree :data="treeData" :props="defaultProps"  @node-click="handleNodeClick" :render-content="renderContent"></el-tree> -->

      <!--  -->
      <el-tree
        v-if="viewModel.treeNode"
        ref="filetree"
        :data="[viewModel.treeNode.treeData]"
        node-key="id"
        default-expand-all="false"
        @node-click="handleNodeClick"
        @node-contextmenu="handleRightClick"
        @node-expand="nodeExpand"
        @node-collapse="nodeCollapse"
        :highlight-current="true"
        :expand-on-click-node="false"
        :render-content="renderContent"
        :allow-drop="allowDrop"
        :allow-drag="allowDrag">
      </el-tree>

      
      <modal :show="modal.showEditName || modal.showAddFolder" body-classes="p-0">
        <el-form :ref="`folderName`" v-if="modal.showEditName || modal.showAddFolder" @submit.prevent :rules="folderNameRules" :model="modal" label-position="top">
          <div class="pl-3 pt-3 pb-2 bg-light-fracture1 rounded-top">
            <h4 class="modal-title" v-if="modal.showAddFolder">{{$t("ツリー.10")}}</h4>
            <h4 class="modal-title" v-if="modal.showEditName">{{$t("ツリー.8")}}</h4>
          </div>
          <div class="container-fluid mt-1">
            <div class="card mb-4" style="font-size:0.8rem;">
              <div v-if="modal.showAddFolder && modal.modalRootType == 'folder'" class="pb-1 pt-1">
                フォルダ作成先 <i class="fa fa-folder mr-1 text-default"></i>{{modal.modalRootName}}
              </div>
              <div v-if="modal.showAddFolder && modal.modalRootType == 'project'" class="pb-1 pt-1">
                フォルダ作成先 <i class="fa fa-project-diagram mr-1 text-primary"></i>{{modal.modalRootName}}
              </div>
              <h4 class="formInput-section">{{modal.modalLabel}} <require-tag /></h4>
              <el-form-item class="flex-grow-1" prop="modalValue">
                <el-input
                  type="text"
                  v-model="modal.modalValue"
                  ref="modalInput"
                  @focus="onForcusModalInput">
                </el-input>
              </el-form-item>
              <div class="d-flex p-3">
                <div class="my-box flex-fill pr-1">
                  <base-button
                    block
                    type="secondary"
                    @click="onClickModalCancel"
                    >{{$t("共通.13")}}</base-button
                  >
                </div>
                <div class="my-box flex-fill pl-1">
                  <base-button
                    block
                    type="primary"
                    @click="setModalValue"           
                    >{{$t("共通.14")}}</base-button
                  >
                </div>
              </div>
              <!-- <div class="card-body">
                <div class="row">
                  <div class="col-md-12">
                    <base-input v-bind:label="modalLabel">
                      <el-input
                        type="text"
                        v-model="modalValue"
                        ref="modalInput"
                        @focus="onForcusModalInput"></el-input>
                    </base-input>
                    <base-button block type="primary" @click="setModalValue">OK</base-button>
                  </div>
                </div>
              </div> -->
            </div>
          </div>
        </el-form>
      </modal>
    </div>
    <modal v-show="modal.showLevelEdit" v-model:show="modal.showLevelEdit" size="lg" body-classes="p-0" :maskClickClose="false" style="z-index: 1060;">
      <!-- <tree-level-edit v-if="false" ref="treeLevelEdit" :treeChild="newChild" @cancel="cancelLevelEdit" @save="saveLevelEdit"></tree-level-edit> -->
      <form-setting-modal ref="formSettingModaltreeLevelEdit" v-if="modal.showLevelEdit && viewModel.formSetting" :viewModel="viewModel.formSetting" :treeChild="newChild" @onCancel="cancelLevelEdit" @onSave="saveLevelEdit"></form-setting-modal>

    </modal>
    <modal v-show="modal.fileUpload" v-model:show="modal.fileUpload" size="lg" body-classes="p-0" :maskClickClose="false">
      <file-upload-modal ref="FileUploadModal" v-if="modal.fileUpload && viewModel.fileUpload" :viewModel="viewModel.fileUpload" @onCancel="cancelUpload" @onSave="saveUpload"></file-upload-modal>
    </modal>
    <modal v-show="showConfirm" v-model:show="showConfirm"  style="z-index:1061 !important;" body-classes="p-0">
      <confirm-modal 
        :title="confirm.title"
        :message="confirm.message" 
        :leftButtonLabel="confirm.leftButtonLabel" 
        :rightButtonLabel="confirm.rightButtonLabel" 
        @onClickLeftButton="onClickConfirmLeft"
        @onClickRightButton="onClickConfirmRight"
      />
    </modal>
  </div>
</template>
<style scoped>
.tree-context-menu {
  position: fixed;
  z-index: 1050;
}

.context-menu {
  box-shadow:  0 50px 100px rgb(50 50 93 / 10%), 0 15px 35px rgb(50 50 93 / 15%), 0 5px 15px rgb(0 0 0 / 10%) !important;
}

</style>
<style>
.drawer-tree-wrapper .menuDropdownButton{
  display: none;
}
</style>
<script>
import Short from "short-uuid";
import Modal from "@/components/Modal";
import TreeModel from "../../../appModel/Tree/TreeModel";
import DropzoneFileUpload from "@/components/Inputs/DropzoneFileUpload";
import TreeLevelEdit from "./TreeLevelEdit.vue";
import FormSettingModal from "@/appViews/components/FileView/Modal/FormSettingModal"
import FileUploadModal from "@/appViews/components/FileView/Modal/FileUploadModal"
import FormSettingViewModel from "@/appViews/components/FileView/ViewModel/FormSettingViewModel"
import FileUploadViewModel from "@/appViews/components/FileView/ViewModel/FileUploadViewModel"
import TreeViewModel from "@/appViews/components/FileView/ViewModel/TreeViewModel"
import ValidateUtil from "@/appUtils/ValidateUtil"
import TenantStorage from "@/appUtils/TenantStorage"
import { useToast } from "vue-toastification";

export default {
  name: "tree-list",
  components: {
    Modal,
    DropzoneFileUpload,
    TreeLevelEdit,
    FormSettingModal,
    FileUploadModal
  },
  props: {
    defaultProps: Object,
    project: Object,
    projectId: String
  },
  data() {
    return {
      treeData: [], // ツリーのデータ
      tenantStorage: null,
      tenantId: null,
      fileMultiple: [],
      toastId: "TreeList",
      inputs: {
        fileSingle: [],
      },
      folderNameRules: {
        modalValue: [{ required: true, validator: this.checkFolderName, trigger: 'blur' }]
      },
      dbData: {},
      context_position: {
        left: 0,
        top: 0
      },
      treeContextShow: false,
      height: window.innerHeight,
      isProject: false,
      isBackImage: false,
      isBackMap: false,
      isDepthLvLimit: false,
      treeDepthLvLimit: 5,
      modal: {
        showAddFolder: false,
        showEditName: false, // 名称変更モーダルのフラグ
        showUploadFile: false, // ファイル追加モーダルのフラグ
        showLevelEdit: false, // 検査階層モーダルのフラグ
        fileUpload: false,
        modalLabel: "フォルダ名",
        modalTitle: "新規フォルダ作成",
        modalValue: "",
        modalRootName: "",
        modalRootType: "project"
      },
      showConfirm: false,
      selectedNode: null,
      tree: {
        addFolder: false,
        addForm: false,
        editForm: false,
        addFile: false,
        rename: false,
        delete: false,
        div1: false,
        div2: false,
        div3: false
      },
      confirm: {
        tirle: "削除確認",
        message: "",
        leftButtonLabel: "キャンセル",
        rightButtonLabel: "削除",
        leftButtonFn: null,
        rightButtonFn: null
      },
      loader: null,
      viewModel: {
        formSetting: null,
        treeNode: null,
        fileUpload: null
      },
      maxTree: 5
    };
  },
  beforeCreate() {
    //インスタンスは生成されたがデータが初期化される前
  },
  created() {
    
  },
  beforeMount() {
    //インスタンスが DOM 要素にマウントされる前
  },
  async mounted() {
    //インスタンスが DOM 要素にマウントされた後
    const tenantStore = this.$store.state.tenant
    this.tenantId = tenantStore.id
    this.tenantStorage = new TenantStorage(this.tenantId)
    
    //インスタンスが生成され､且つデータが初期化された後
    if (!this.projectId) {
      this.$router.push({
        name: 'Projects'
      })
    }
    try {
      await this.loadProjectTreeData()
      
      this.$nextTick(function() {
        try {
          this.setInitnode()
        } catch (e) {

          this.$router.push({
            name: 'Projects'
          })
        }
      }.bind(this))
      
      window.addEventListener("scroll", this.handleScroll);
    } catch (e) {
      this.$router.push({
        name: 'Projects'
      })
    }

    // ページ表示時に実行
    this.handleResize();
    window.addEventListener('resize', this.handleResize)

  },
  beforeUpdate() {
    //データは更新されたが DOM に適用される前
  },
  updated() {
    //データが更新され､且つ DOM に適用された後
  },
  beforeUnmount() {
    //Vue インスタンスが破壊される前
    window.removeEventListener('resize', this.handleResize)
    window.removeEventListener("scroll", this.handleScroll);
  },
  unmounted() {
    //Vue インスタンスが破壊された後
  },
  methods: {
    /**
     * 左クリックイベントリスナー
     */
    onleftclick() {
      this.treeContextShow = false;
      
    },

    setInitnode(invokeEvent = false) {
      // 初期表示時はユーザ作成ノードがあれば選択する
      // なければ検査マスタを選択状態にする
      let tree = this.$refs.filetree;
      if (!tree){
        return
      }
      
      let data = this.viewModel.treeNode.treeData
      let id = data.id
      console.log(`setInitnode ${id}`)
      // if (this.viewModel.treeNode.treeData.children.length > 1) {
        // ユーザ作成ノードの先頭を選択状態に
        // console.log(`setInitnode usernode ${this.viewModel.treeNode.treeData.children[1].sk}`)
        // key = this.viewModel.treeNode.treeData.children[1].sk
      // }

      tree.setCurrentKey(id);
      if (invokeEvent) {
        this.handleNodeClick(data)
      }
    },
    /**
     * 選択中ノードと同じノードであるか判定
     * @param {*} data 
    */
    isSameNode(data) {
      let selectedNode = this.$store.state.selectedNode;
      return selectedNode == data;
    },
    /**
     * 右クリックイベントリスナー
     */
    async handleRightClick(e, data) {
      if (e) {
        e.preventDefault();
      }
      // 同じノードであるかのフラグ
      const isSameNode = this.isSameNode(data)

      // 右クリックしたノードを選択状態に
      let tree = this.$refs.filetree;
      tree.setCurrentKey(data.id);
      // 左クリックと同様にカレントに設定
      await this.updateSelectedNode(data);
      
      this.$emit("handleRightClick", data, isSameNode, e);
      return
      // 表示制御
      this.isProject = false;
      this.tree = {
        addFolder: false,
        addForm: false,
        editForm: false,
        addFile: false,
        rename: false,
        delete: false,
        div1: false,
        div2: false,
        div3: false
      }
      
      switch (data.type.toLowerCase()) {
      case "backimage":
        this.tree = {
          addFolder: false,
          addForm: false,
          editForm: true,
          addFile: false,
          rename: false,
          delete: true,
          div1: false,
          div2: false,
          div3: true
        }
        this.isBackImage = true;
        this.isMap = false;
        break;
      case "map":
        this.tree = {
          addFolder: false,
          addForm: false,
          editForm: true,
          addFile: false,
          rename: false,
          delete: true,
          div1: false,
          div2: false,
          div3: true
        }
        this.isBackImage = true;
        this.isMap = true;
        break;
      case "nobackimage":
        this.tree = {
          addFolder: false,
          addForm: false,
          editForm: true,
          addFile: false,
          rename: false,
          delete: true,
          div1: false,
          div2: false,
          div3: true
        }
        this.isBackImage = true;
        this.isMap = true;
        break;
      case "inspectmaster":
        // 検査マスタは右クリック無し

        return
      case "project":
        this.isProject = true;
        this.tree = {
          addFolder: true,
          addForm: true,
          editForm: false,
          addFile: false,
          rename: false,
          delete: false,
          div1: true,
          div2: false,
          div3: false
        }
        break;
      case "folder":{
        let addFolderFlag = data.lsiInt1 < 4
        this.tree = {
          addFolder: addFolderFlag,
          addForm: true,
          editForm: false,
          addFile: true,
          rename: true,
          delete: true,
          div1: addFolderFlag,
          div2: true,
          div3: true
        }
        this.isBackImage = false;
        this.isMap = false;
        this.isProject = false;
        
        break;
      }

      case "file":{
        this.tree = {
          addFolder: false,
          addForm: false,
          editForm: false,
          addFile: false,
          rename: false,
          delete: true,
          div1: false,
          div2: false,
          div3: false
        }
        this.isBackImage = false;
        this.isMap = false;
        this.isProject = false;
        break;
      }
      default:
        this.treeContextShow = false
        break;
      }

      

      if (data.depthLv >= this.treeDepthLvLimit) {
        // 階層上限超え
        this.isDepthLvLimit = true;
      } else {
        this.isDepthLvLimit = false;
      }

      // 一時表示
      this.context_position = {
        bottom: null,
        top: `${e.clientY}px`,
        left: `${e.pageX}px`
      };
      this.treeContextShow = true

      let menuHeight = 0;
      const _this = this;
      this.$nextTick(function() {
        // メニュー高さ取得（表示してからでないと0となる）
        menuHeight = _this.$refs.contextMenu.clientHeight;
        menuHeight = document.querySelector('#contextMenu').clientHeight;

        // 右クリック位置Y ＋ メニューの高さ > window高さなら
        // クリック位置をbottomとして表示する
        
        if ((e.clientY + menuHeight) > _this.height) {
          _this.context_position = {
            top: `${e.clientY - menuHeight}px`,
            left: `${e.pageX}px`
          };
        } else {
          _this.context_position = {
            bottom: null,
            top: `${e.clientY}px`,
            left: `${e.pageX}px`
          };
        }
      }.bind(this))

    },
    /**
     * プロジェクトIDからツリー情報を取得する
     */
    async loadProjectTreeData() {
      const user = await this.$root.getUserInfo()
      this.viewModel.treeNode = new TreeViewModel(this.projectId, user.sub, this.tenantId)
      await this.viewModel.treeNode.getTreeData()
      this.viewModel.treeNode.treeData.label = this.project.project.name;

    },
    /**
     * ツリー情報を更新する
     */
    async updateProjectTreeData() {
      try {

        const currentData = await TreeModel.getTree(this.projectId);

        this.viewModel.treeNode.treeData = this.treeData[0];
        
        if (!currentData) {
          // 新規追加

          await TreeModel.addTree(this.viewModel.treeNode);
        } else {
          // 更新
          
          await TreeModel.updateTree(this.viewModel.treeNode);
        }

        //await this.loadProjectTreeData()
      } catch (e) {
        console.log(`更新失敗`);
        throw e;
      }
    },
    /**
     * ツリーノードクリックのイベントリスナー
     */
    async handleNodeClick(data) {
      this.treeContextShow = false;

      await this.updateSelectedNode(data);
      this.$emit("clicked-node", data);
    },
    /**
     * ノード選択時のイベントリスナー
     */
    async updateSelectedNode(data) {
      let selectedNode = this.$store.state.selectedNode;
      selectedNode = data;
     
      this.$store.commit("setSelectedNode", selectedNode);
    },
    /**
     * ノード描画時にノード毎に呼び出されるデリゲート
     */
    renderContent(h, { node, data, store }) {
      try {

        let retObj = null;
        
        const currentKey = this.$refs.filetree.getCurrentKey();
        const isOpen = currentKey == node.data.id;

        switch (data.type) {
        case "folder":
          if (isOpen) {
            retObj = (
              <span class="el-tree-node__label">
                <span class="fa fa-folder-open mr-1 text-default"></span>
                {node.data.label}
              </span>
            );
          } else {
            retObj = (
              <span class="el-tree-node__label">
                <span class="fa fa-folder mr-1 text-default"></span>
                {node.data.label}
              </span>
            );
          }
          break;
        case "project":
          retObj = (
            <span class="el-tree-node__label">
              <span class="fa fa-project-diagram mr-1 text-primary"></span>
              {node.data.label}
            </span>
          );

          break;
        case "backimage":
          retObj = (
            <span class="el-tree-node__label">
              <span class="fa fa-layer-group mr-1 text-primary"></span>
              {node.data.label}
            </span>
          );
          break;
        case "map":
          retObj = (
            <span class="el-tree-node__label">
              <span class="fa fa-map-marked-alt mr-1 text-primary"></span>
              {node.data.label}
            </span>
          );
          break;
        case "nobackimage":
          retObj = (
            <span class="el-tree-node__label">
              <span class="fa fa-bars mr-1 text-primary"></span>
              {node.data.label}
            </span>
          );
          break;
        case "file":
          retObj = (
            <span class="el-tree-node__label">
              <span class="far fa-file mr-1 text-primary"></span>
              {node.data.label}
            </span>
          );
          break;
        default:
          retObj = (
            <span class="el-tree-node__label">
              <span class="fa fa-folder mr-1 text-primary"></span>
              {node.data.label}
            </span>
          );
        }
        return retObj;
      } catch (e) {
        console.log(JSON.stringify(e))
      }
    },
    /**
     * ノード展開
     */
    nodeExpand(node) {
      //node.isOpen = true
    },
    /**
     *
     */
    nodeCollapse(node) {
      //node.isOpen = false
    },
    /**
     * ノード毎におけるドロップの可否を返す
     */
    allowDrop(draggingNode, dropNode, type) {
      if (dropNode.data.label === "Level two 3-1") {
        return type !== "inner";
      } else {
        return true;
      }
    },
    /**
     * ノード毎におけるドラッグの可否を返す
     */
    allowDrag(draggingNode) {
      let isDraggable = true;
      switch (draggingNode.data.type.toLowerCase()) {
      case "project":
        isDraggable = false;
        break;
      case "backimage":
        isDraggable = false;
        break;
      case "map":
        isDraggable = false;
        break;
      case "nobackimage":
        isDraggable = false;
        break;
      case "inspectmaster":
        isDraggable = false;
        break
      default:
        isDraggable = true;
        break;
      }
      
      return isDraggable;
    },
    /**
     * 検査マスタ編集
     */
    handlerMenuInspectMaster() {
      // this.$router.push({
      //   name: "InspectMasterList"
      // })

      //@transfer="transferProc" :transferArgs="inspectMasterListArgs"
      this.$emit('transfer', {key: "inspectMasterListArgs", values: {}})
    },
    /**
     * フォルダ追加
     */
    async handlerMenuAddFolder() {
      const selectedNode = this.$refs.filetree.getCurrentNode();
      
      await this.viewModel.treeNode.getNewNode(selectedNode)
      this.viewModel.treeNode.nodeData.treeItem.type = "folder"
      
      this.modal.showAddFolder = true
      this.modal.showEditName = false;
      this.modal.modalValue = "";
      this.modal.modalLabel = this.$t("ツリー.7");
      this.modal.modalTitle = "フォルダ名";

      this.modal.modalRootName = selectedNode.label
      this.modal.modalRootType = selectedNode.type
      
      this.$refs.filetree.setCurrentKey(selectedNode.id);
      
    },
    /**
     * 名前の変更
     */
    async handlerMenuRename() {
      const selectedNode = this.$refs.filetree.getCurrentNode();
      await this.viewModel.treeNode.getEditNode(selectedNode.sk)
      
      this.modal.showAddFolder = false
      this.modal.showEditName = true;
      this.modal.modalValue = selectedNode.label;
      this.modal.modalLabel = this.$t("ツリー.7");
      this.modal.modalTitle = "フォルダ名";
      
      this.$refs.filetree.setCurrentKey(selectedNode.id);
      
      // this.treeRename(selectedNode);
    },
    handlerMenuAddFile() {},
    /**
     * 検査を追加
     */
    async handlerMenuAddInspect() {
      const selectedNode = this.$refs.filetree.getCurrentNode();
      // await this.$refs.formSettingModaltreeLevelEdit.init()
      await this.treeAddInspect(selectedNode);
    },
    /**
     * 背景図追加
     */
    handlerMenuAddBackImage() {
      const selectedNode = this.$refs.filetree.getCurrentNode();
      this.treeAddBackImage(selectedNode);
    },
    /**
     * 背景図設定
     */
    async handlerMenuBackImageSetting() {
      try {
        this.showLoader()
        const selectedNode = this.$refs.filetree.getCurrentNode();
        // await this.$refs.formSettingModaltreeLevelEdit.init();
        await this.treeEditInspect(selectedNode);
      } finally {
        this.hideLoader()
      }
      
    },
    /**
     * 地図追加
     */
    handlerMenuAddMap() {
      const selectedNode = this.$refs.filetree.getCurrentNode();
      this.treeAddMap(selectedNode);
      
    },
    /**
     * コンテキストメニューの削除押下時の処理
     */
    async handlerMenuDeleteNode() {
      const selectedNode = this.$refs.filetree.getCurrentNode();
      
      // 子ノードの存在チェック
      if (selectedNode.children && selectedNode.children.length > 0) {
        this.runToast("子ノードを保持している親ノードは削除できません", "error")
        return 
      }
      
      let isForm = false

      let message = ""
      switch (selectedNode.type) {
      case "backimage":
        isForm = true
        message = `フォーム「${selectedNode.label}」を削除します。削除後は復元できません。`
        break;
      case "map":
        isForm = true
        message = `フォーム「${selectedNode.label}」を削除します。削除後は復元できません。`
        break;
      case "nobackimage":
        isForm = true
        message = `フォーム「${selectedNode.label}」を削除します。削除後は復元できません。`
        break;
      case "folder":
        message = `フォルダ「${selectedNode.label}」を削除します。削除後は復元できません。`
        break
      default:
        message = ``
        break
      }

      // 検査箇所存在チェック
      if (isForm) {
        const nodeId = selectedNode.id
        if (await this.viewModel.treeNode.hasInspectPlace(nodeId)) {
          this.runToast("検査箇所が存在するためフォーム削除は行えません", "error")
          return 
        }
      }

      // 変更確認
      this.confirm.message = message
      this.confirm.leftButtonLabel = "キャンセル"
      this.confirm.rightButtonLabel = "削除"
      this.confirm.leftButtonFn = function() {
        this.showConfirm = false
      }.bind(this)
      this.confirm.rightButtonFn = async function() {
        this.showConfirm = false
        this.showLoader()
        try {
          await this.viewModel.treeNode.getEditNode(selectedNode.sk)
          await this.viewModel.treeNode.delete()

          // 最近使用したファイルから削除
          

          // 背景図のノードであるか
          if (selectedNode.type == 'backimage') {
            // 背景図レコードも削除する
            this.viewModel.formSetting = new FormSettingViewModel(this.tenantId, this.projectId, null, selectedNode.id)
            await this.viewModel.formSetting.init()
            
            const s3Key = this.viewModel.formSetting.backImage.filePath
            await this.tenantStorage.delete(s3Key)
            await this.viewModel.formSetting.delete()
            
          }
          if (isForm) {
            // フォームノード選択時はメイン画面が表示されている場合があるため、強制的にルートを選択
            this.$emit("clicked-node", this.viewModel.treeNode.treeData);
            this.$refs.filetree.setCurrentKey(this.viewModel.treeNode.treeData.sk);  
          }

          // ツリーを再読み込み
          await this.loadProjectTreeData()
          
        } catch (e) {
          console.log(JSON.stringify(e))
          throw e
        } finally {
          this.hideLoader()
        }
        // await this.treeDeleteNode(selectedNode);
      }.bind(this)
      this.showConfirm = true
    },
    
    handlerMenuPlaceList() {
      // const selectedNode = this.$refs.filetree.getCurrentNode();
      const selectedNode = this.$store.state.selectedNode
      
      this.$emit('transfer', {key: "inspectPlaceListArgs", values: selectedNode})
    },
    /**
     * ファイル追加
     */
    handlerAddfile() {
      const selectedNode = this.$refs.filetree.getCurrentNode();
      if (!selectedNode) {
        return;
      }
      this.viewModel.fileUpload = new FileUploadViewModel(this.tenantId, this.projectId, selectedNode)
      this.modal.fileUpload = true
    },
    async saveUpload() {
      await this.loadProjectTreeData()
      this.modal.fileUpload = false
    },
    async cancelUpload() {
      this.modal.fileUpload = false
    },
    treeAddFolder(node) {
      
      let selectedNode = node;
      if (!selectedNode) {
        return;
      }

      let folderId = Short.generate();


      let newChild = {
        label: "新規フォルダ",
        id: folderId,
        type: "folder",
        path: "",
        order: 0,
        deleteFlag: false,
        fileSize: 0,
        fileList: [],
      };

      if (!selectedNode.children) {
        selectedNode["children"] = [];
      }
      selectedNode.children.push(newChild);
      let tree = this.$refs.filetree;
      this.modal.showAddFolder = true
      this.modal.showEditName = false;
      this.modal.modalValue = this.$t("ツリー.9");
      this.modal.modalLabel = "新規フォルダ作成";
      this.modal.modalTitle = this.$t("ツリー.7");
      
      setTimeout(function () {
        tree.setCurrentKey(folderId);
      }, 100);
    },
    treeRename(node) {

      let selectedNode = node;
      if (!selectedNode) {
        return;
      }
      let tree = this.$refs.filetree;
      this.modal.showAddFolder = false
      this.modal.showEditName = true;
      this.modal.modalValue = node.label;
      this.modal.modalLabel = "新しい名前";
      this.modal.modalTitle = "名前の変更";

      setTimeout(function () {
        tree.setCurrentKey(node.id);
      }, 100);
    },
    async onClickModalCancel() {
      this.modal.showEditName = false;
      this.modal.showAddFolder = false;
    },
    async setModalValue() {

      // this.viewModel.treeNode.treeItem.label = this.modal.modalValue;
      // let currentNode = this.$refs.filetree.getCurrentNode();
      // currentNode.label = this.modal.modalValue;

      this.$refs.folderName.validate(async function(result, object) {
        if (!result) {
          this.runToast("入力内容にエラーがあります。", "error")
          return
        }
        this.viewModel.treeNode.nodeData.treeItem.label = this.modal.modalValue; 
        await this.viewModel.treeNode.save()

        await this.loadProjectTreeData()
        // await this.viewModel.treeNode.getTreeData()
        this.modal.showEditName = false;
        this.modal.showAddFolder = false;

        // this.updateProjectTreeData();
      }.bind(this))


      
    },
    
    /**
     * 検査を追加処理
     */
    async treeAddInspect(node) {

      const selectedNode = node;
      if (!selectedNode) {
        return;
      }
      let id = Short.generate();

      // 選択ノードを保持
      this.selectedNode = selectedNode;

      if (!selectedNode.children) {
        selectedNode["children"] = [];
      }

      // TODO: skを渡す
      this.viewModel.formSetting = new FormSettingViewModel(this.tenantId, this.projectId, this.selectedNode)
      this.modal.showLevelEdit = true;


    },
    /**
     * 検査を更新処理
     */
    async treeEditInspect(node) {

      const selectedNode = node;
      if (!selectedNode) {
        return;
      }
      
      // 選択ノードを保持
      this.selectedNode = selectedNode;

      if (!selectedNode.children) {
        selectedNode["children"] = [];
      }

      this.viewModel.formSetting = new FormSettingViewModel(this.tenantId, this.projectId, null, this.selectedNode.id)
      await this.viewModel.formSetting.init()
      this.modal.showLevelEdit = true;
      this.$nextTick(async function(){
        await this.$refs.formSettingModaltreeLevelEdit.init();
      }.bind(this))

    },
    /**
     * 背景図追加処理
     */
    treeAddBackImage(node) {

      /**
       * TODO:
       * 以下の処理はノードをいきなり追加しているが、
       * 背景図設定をModalで表示させ、Modalで保存ボタン押下時にノードを追加するように修正する。
       *
       */

      const selectedNode = node;
      if (!selectedNode) {
        return;
      }
      let folderId = Short.generate();
      

      let newChild = {
        label: "新規背景図",
        id: folderId,
        type: "backimage",
        path: "",
        order: 0,
        deleteFlag: false,
        fileSize: 0,
        fileList: [],
      };

      if (!selectedNode.children) {
        selectedNode["children"] = [];
        //this.$set(selectedNode, 'children', []);
      }
      selectedNode.children.push(newChild);

      let tree = this.$refs.filetree;
      this.modal.showEditName = true;
      this.modal.modalValue = "新規背景図";
      this.modal.modalLabel = "新規背景図作成";
      this.modal.modalTitle = "背景図名";
      setTimeout(function () {
        tree.setCurrentKey(folderId);
      }, 100);

    },
    /**
     * 地図追加処理
     */
    treeAddMap(node) {
      
      const selectedNode = node;
      if (!selectedNode) {
        return;
      }
      let folderId = Short.generate();
      
      let newChild = {
        label: "新規地図",
        id: folderId,
        type: "map",
        path: "",
        order: 0,
        deleteFlag: false,
        fileSize: 0,
        fileList: [],
      };
      if (!selectedNode.children) {
        selectedNode["children"] = [];
        //this.$set(selectedNode, 'children', []);
      }
      selectedNode.children.push(newChild);
      let tree = this.$refs.filetree;
      this.modal.showEditName = true;
      this.modal.modalValue = "新規地図";
      this.modal.modalLabel = "新規地図作成";
      this.modal.modalTitle = "地図名";
      setTimeout(function () {
        
        tree.setCurrentKey(folderId);
      }, 100);
    },
    async treeDeleteNode(node) {
      
    },
    onForcusModalInput(event) {
      this.$refs.modalInput.select();
    },
    /**
     * 検査階層のモーダルがキャンセルされた時の処理です。
     */
    cancelLevelEdit() {
      
      this.modal.showLevelEdit = false;
    },
    /**
     * 検査階層のモーダルが登録された時の処理です。
     */
    async saveLevelEdit(treeChild) {

      // 保持しておいた選択ノードに追加
      // this.selectedNode.children.push(treeChild);

      // DBに登録
      // this.updateProjectTreeData();
      await this.loadProjectTreeData()
      this.modal.showLevelEdit = false;
      const selectedNode = this.$refs.filetree.getCurrentNode();
      this.handleNodeClick(selectedNode)
    },
    /**
     * ファイルアップロード
     */
    fileUpload() {
      
      let value = this.$refs.fileUploadArea.value;
      
    },
    /**
     * リサイズのイベントリスナー
     */
    handleResize: function() {
      // windowwのresizeのたびに発生
      // this.width = window.innerWidth;
      this.height = window.innerHeight;
    },
    /**
     * スクロール時のイベントリスナー
     */
    handleScroll: function() {
      this.treeContextShow = false;
    },
    async checkFolderName(rule, value, callback){
      // 同一フォルダ名チェック
      // const selectedNode = this.$refs.filetree.getCurrentNode();
      let ret = await this.viewModel.treeNode.duplicationCheck(this.modal.modalValue)
      if (!ret){
        callback(new Error(`同一階層に同じフォルダ名が存在しています。`))
      } else {
        if (ValidateUtil.checkBase(value, callback, 50, true, false, false)) {
          callback()
        }
      }
      
    },
    /**
     * 処理中インジケーターを表示します。
     * @returns 表示したインジケーター
     */
    showLoader() {
      this.loader = this.$loading.show({
        container: null,
        canCancel: false,
        color: "#E4007F",
        width: 64,
        height: 64,
        backgroundColor: "#ffffff",
        opacity: 0.5,
        isFullPage: true,
        zIndex: 9999,
      })
    },
    /**
     * 処理中インジケーターを閉じます。
     * @paramas {Object} loader 表示したインジケーター
     */
    hideLoader() {
      this.loader.hide();
    },
    onClickConfirmLeft() {
      this.confirm.leftButtonFn()
    },
    onClickConfirmRight() {
      this.confirm.rightButtonFn()
    },
    // ----------------
    // トースト
    // ----------------
    /**
     * トースト表示
     */
    runToast(message, type) {
      const pos = 'bottom-center'
      const toast = useToast();
      toast[type](message, {
        hideProgressBar: true,
        icon: false,
        toastClassName: ["custome-toast-class"],
        closeButton: false,
        position: pos,
        id: this.toastId
      });
    },
    /**
     * トースト非表示
     */
    hideToast() {
      const toast = useToast();
      toast.dismiss(this.toastId)
    }
  },
};
</script>
<style></style>
